<template>
    <money v-model="localValue" class="form-control" size="lg" v-bind="money"></money>
</template>

<script>
import { Money } from 'v-money'
import debounce from 'lodash/debounce';
export default {
    props: ['value', 'type'],
    components: { Money },

    data() {
        return {
            localValue: null,
            money: {
                decimal: ',',
                thousands: ',',
                prefix: '',
                suffix: ' ' + ((this.type) ? this.$t(this.type) : ''),
                precision: 0,
                masked: false /* doesn't work with directive */
            }
        }
    },
    watch: {
        localValue: debounce(function (newVal) {
            this.$emit('input', this.localValue);
        }, 10),
    },
    created() {
        this.localValue = this.value;
    },
    methods: {

    }

}
</script>

<style>

</style>
